import { render, staticRenderFns } from "./WordSettingsController.vue?vue&type=template&id=2a6174c0&scoped=true"
import script from "./WordSettingsController.vue?vue&type=script&lang=js"
export * from "./WordSettingsController.vue?vue&type=script&lang=js"
import style0 from "./WordSettingsController.vue?vue&type=style&index=0&id=2a6174c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6174c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a6174c0')) {
      api.createRecord('2a6174c0', component.options)
    } else {
      api.reload('2a6174c0', component.options)
    }
    module.hot.accept("./WordSettingsController.vue?vue&type=template&id=2a6174c0&scoped=true", function () {
      api.rerender('2a6174c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/QuestionConfig/WordSettingsController.vue"
export default component.exports